import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FilterButton, InnerFilter } from '../../../../../../../components';
import styles from './NegociacoesSalvasFilters.module.scss';
import { NegociacoesSalvasFilterKey, UseNegociacoesSalvasFiltersProps } from './useNegociacoesSalvasFilters';

export type NegociacoesSalvasFiltersProps = Omit<ComponentProps<'section'>, 'onChange'> & UseNegociacoesSalvasFiltersProps;

export const NegociacoesSalvasFilters = ({
  className,
  data,
  value,
  loading,
  onSearch,
  onChange,
  onClean,
  onCleanAll,
  onSelectAll,
  ...props
}: NegociacoesSalvasFiltersProps) => {
  const handleClose = (key: NegociacoesSalvasFilterKey) => () => onSearch(key, '');
  const handleClean = (key: NegociacoesSalvasFilterKey) => () => onClean(key);

  return (
    <section {...props} className={classNames(styles.wrapper, className)}>
      <div className={styles.line}>
        <InnerFilter
          type="check"
          placeholder="Produto"
          data={data.productIds ?? []}
          value={value.productIds ?? []}
          isLoading={loading.productIds}
          textSearch="Busque por um produto"
          textLoading="Carregando produtos..."
          menuAutoWidth={false}
          menuStyle={{ minWidth: 250 }}
          onSearch={query => onSearch('productIds', query)}
          onChange={nextValue => onChange('productIds', nextValue)}
          onClose={handleClose('productIds')}
          onClean={handleClean('productIds')}
        />

        <InnerFilter
          type="check"
          placeholder="Loja"
          data={data.storeIds ?? []}
          value={value.storeIds ?? []}
          isLoading={loading.storeIds}
          textSearch="Busque por uma loja"
          textLoading="Carregando lojas..."
          onSearch={query => onSearch('storeIds', query)}
          onChange={nextValue => onChange('storeIds', nextValue)}
          onClose={handleClose('storeIds')}
          onClean={handleClean('storeIds')}
          selectAll={{ onSelectAll: checked => onSelectAll('storeIds', checked) }}
        />

        <InnerFilter
          type="check"
          placeholder="Cluster"
          data={data.clusters ?? []}
          value={value.clusters ?? []}
          isLoading={loading.clusters}
          textSearch="Busque por um cluster"
          textLoading="Carregando clusters..."
          onSearch={query => onSearch('clusters', query)}
          onChange={nextValue => onChange('clusters', nextValue)}
          onClose={handleClose('clusters')}
          onClean={handleClean('clusters')}
        />

        <InnerFilter
          type="check"
          placeholder="Agrupamento"
          data={data.visionSaved ?? []}
          value={value.visionSaved ?? []}
          isLoading={loading.visionSaved}
          searchable={false}
          onSearch={query => onSearch('visionSaved', query)}
          onChange={nextValue => onChange('visionSaved', nextValue)}
          onClose={handleClose('visionSaved')}
          onClean={handleClean('visionSaved')}
        />

        <InnerFilter
          type="check"
          placeholder="Fornecedor"
          data={data.supplier ?? []}
          value={value.supplier ?? []}
          isLoading={loading.supplier}
          textSearch="Busque por um fornecedor"
          textLoading="Carregando fornecedores..."
          onSearch={query => onSearch('supplier', query)}
          onChange={nextValue => onChange('supplier', nextValue)}
          onClose={handleClose('supplier')}
          onClean={handleClean('supplier')}
          selectAll={{ onSelectAll: checked => onSelectAll('supplier', checked) }}
        />

        <InnerFilter
          type="check"
          placeholder="Responsável"
          data={data.owner ?? []}
          value={value.owner ?? []}
          isLoading={loading.owner}
          textLoading="Carregando responsáveis..."
          searchable={false}
          onSearch={query => onSearch('owner', query)}
          onChange={nextValue => onChange('owner', nextValue)}
          onClose={handleClose('owner')}
          onClean={handleClean('owner')}
        />

        <InnerFilter
          type="select"
          placeholder="Status"
          data={data.status ?? []}
          value={value.status?.[0] ?? null}
          isLoading={loading.status}
          textLoading="Carregando status..."
          searchable={false}
          onChange={nextValue => onChange('status', nextValue ? [String(nextValue)] : [])}
          onClean={handleClean('status')}
        />
      </div>

      <FilterButton type="button" onClick={onCleanAll}>
        Limpar Filtros
      </FilterButton>
    </section>
  );
};
